import React from "react";
import { MapPin, Phone, Instagram, ShieldCheck } from "lucide-react";
import { CONTACT, IMG } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative bg-ocean-deep pt-16 text-white" data-testid="footer">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src={IMG.logo} alt="Dive Master" className="h-16 w-auto" />
              <span className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
                {CONTACT.brand}
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
              Escola de mergulho em Porto Belo. Há mais de {CONTACT.years} anos
              realizando o sonho de respirar debaixo d&apos;água.
            </p>
          </div>

          <div className="space-y-4 text-sm">
            <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/80 transition-colors hover:text-white" data-testid="footer-whatsapp">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-sun" />
              <span>{CONTACT.whatsappDisplay}</span>
            </a>
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/80 transition-colors hover:text-white" data-testid="footer-instagram">
              <Instagram className="mt-0.5 h-4 w-4 shrink-0 text-sun" />
              <span>{CONTACT.instagramHandle}</span>
            </a>
            <div className="flex items-start gap-3 text-white/80">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sun" />
              <span>{CONTACT.address}</span>
            </div>
          </div>

          <div>
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="cta-sun flex w-full items-center justify-center rounded-full px-6 py-4 text-sm font-extrabold uppercase tracking-wide text-white"
              data-testid="footer-cta"
            >
              Falar no WhatsApp
            </a>
            <p className="mt-4 text-xs leading-relaxed text-white/50">
              Atendimento rápido para tirar dúvidas e reservar sua data.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 py-6 text-xs text-white/60 sm:flex-row">
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-4 w-4" />
            <span>CNPJ {CONTACT.cnpj}</span>
          </div>
          <div className="flex items-center gap-5">
            <a href="#" className="transition-colors hover:text-white" data-testid="footer-privacy">Política de privacidade</a>
            <span>© {new Date().getFullYear()} Dive Master</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
